(function () {
	'use strict';

	angular
		.module('wizard-english-test.services')
		.service('NotifyService', NotifyService)

	/** @ngInject */
	function NotifyService(sweetAlert) {
		const NotifyService = {
			notify,
			success,
			error,
			warning
		};

		return NotifyService;

		function notify(config, callback, errCallback) {
			sweetAlert.swal(config).then(callback).catch(errCallback);
		}

		function success(message, title = 'SUCESSO!') {
			notify({
				title: title,
				type: 'success',
				text: message,
				allowOutsideClick: false,
				allowEscapeKey: false,
				allowEnterKey: false
			});
		}

		function error(message, title = 'ERRO!') {
			notify({
				title: title,
				type: 'error',
				text: message,
				allowOutsideClick: false,
				allowEscapeKey: false,
				allowEnterKey: false
			});
		}

		function warning(message, title = 'ATENÇÃO!') {
			notify({
				title: title,
				type: 'warning',
				text: message,
				allowOutsideClick: false,
				allowEscapeKey: false,
				allowEnterKey: false
			});
		}
	}
}());